import { render, staticRenderFns } from "./DoclibPreview.vue?vue&type=template&id=5c477a58&scoped=true"
import script from "./DoclibPreview.vue?vue&type=script&lang=js"
export * from "./DoclibPreview.vue?vue&type=script&lang=js"
import style0 from "./DoclibPreview.vue?vue&type=style&index=0&id=5c477a58&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c477a58",
  null
  
)

export default component.exports